import { Injectable } from '@angular/core';
import { BaseServiceErrorResolverService } from '../../../../../core/services/error-resolvers/base-service-error-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersServiceErrorResolverService extends BaseServiceErrorResolverService {
  codes = {
    ChargesExistsInDb: 'Chargennummer existiert in der Datenbank',
    OrderConcurrencyConflict: 'Die Bestellung wurde zwischenzeitlich geändert',
    OrderCorrectReasonRequired: 'Korrekturgrund ist erforderlich',
    UnprocessableEntity: 'Buchung konnte nicht ausgeführt werden',
    OrderSupplierEmailMissing: 'Der Lieferant hat keine gültige E-Mail-Adresse',
    OrderMailReplyToMissing: 'Antwort an ist in den E-Mail-Einstellungen nicht hinterlegt',
    OrderMailInvalidRecipient: 'Eine E-Mail-Adresse ist ungültig',
    OrderMailNotAllowed: 'Die E-Mail kann nur für eine offene Fremdmarken-Bestellung gesendet werden',
  }
}
